import gql from "graphql-tag"
import {questionFieldsFragment} from "./question"
import {questionGroupFieldsFragment} from "./questionGroup"
import {driverFieldsFragment} from "./driver"
import {interestFieldsFragment} from "./interest"

export const cycleFieldsFragment = gql`
  fragment cycleFields on Schedule {
    Etag
    createdAt
    id
    interestId
    lastENPSTriggeredAt
    lastTriggeredAt
    nextTriggerAt
    nextTriggerAtOverride
    periodType
    periodValue
    reference
    runCount
    startAt
    status
    tenant
    runOnce
    preferences {
      questionSelectionType
      actionBoardUrl
      driverCommentTitle
      eNPSPeriodType
      eNPSPeriodValue 
      groupIds   
      includeActionBoard
      includeDriverComment
      includeENPS
      placeholders {
        tenant
      }
      questionCount
      sendToAll
      teamIds   
      userIds
      emails {
        notificationUserIds
        senderName
        senderUsername
        userSurvey {
            bodyHeading
            bodyText
            ctaHref
            ctaText
            subject
        }
        preSurveyReminder {
            bodyHeading
            bodyText
            ctaHref
            ctaText
            subject
            hoursBefore
        }
        surveyOpenedNotification {
            bodyHeading
            bodyText
            ctaHref
            ctaText
            subject
            enabled
        }
        userDeadlineReminder {
            bodyHeading
            bodyText
            ctaHref
            ctaText
            subject
            hoursBefore
        }
        userReminder {
            bodyHeading
            bodyText
            ctaHref
            ctaText
            subject
            afterDays
        }
      }
    }
  }
`

export const cycleQuestionsFragment = gql`
  fragment cycleQuestions on Schedule {
    questions: questionsV2(orderBy: "createdAt", orderDirection: "asc") {
      results {
        ...questionFields
      }
    }
  }
  ${questionFieldsFragment}
`

export const cycleQuestionGroupsFragment = gql`
  fragment cycleQuestionGroups on Schedule {
    questionGroups {
      results {
        ...questionGroupFields
      }
    }
  }
  ${questionGroupFieldsFragment}
`

export const cycleFieldsWizardFragment = gql`
  fragment cycleFieldsWizard on Schedule {
       ...cycleFields
      interest {
        ...interestFields
      }
      questions: questionsV2(orderBy: "createdAt", orderDirection: "asc") {
        results {
          ...questionFields
          driver: driverV2 {
            ...driverFields
          }
        }
        total
        count
      }
      questionGroups {
        results {
          ...questionGroupFields
        }
      }
  }
  ${cycleFieldsFragment}
  ${questionFieldsFragment}
  ${driverFieldsFragment}
  ${interestFieldsFragment}
  ${questionGroupFieldsFragment}
`
